export const ANIMATION = {
  typing: require('./typing.json'),
  check: require('./check.json'),
}
